import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState({
    name: '',
    city: '',
    time: ''
  });
  const names = ['María', 'Sofía', 'Lucía', 'Valentina', 'Camila', 'Florencia', 'Agustina', 'Martina', 'Julieta', 'Catalina', 'Mariana', 'Carolina', 'Daniela', 'Gabriela', 'Verónica', 'Andrea', 'Silvia', 'Patricia', 'Romina', 'Belén'];
  const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Neuquén', 'Bahía Blanca', 'San Juan', 'Resistencia', 'Santa Fe', 'Corrientes', 'Posadas'];
  const getRandomItem = (array: string[]) => array[Math.floor(Math.random() * array.length)];
  const getRandomTime = () => Math.floor(Math.random() * 30) + 1;
  useEffect(() => {
    const showPopup = () => {
      setCurrentPurchase({
        name: getRandomItem(names),
        city: getRandomItem(cities),
        time: `${getRandomTime()}`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);
    };
    // Show first popup after 5 seconds
    const initialTimeout = setTimeout(showPopup, 5000);
    // Then show every 30 seconds
    const interval = setInterval(showPopup, 30000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  return <AnimatePresence data-id="element-196">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0
    }} exit={{
      opacity: 0,
      y: 50,
      x: -20
    }} transition={{
      duration: 0.4
    }} className="fixed bottom-6 left-6 z-50 max-w-sm" data-id="element-197">
          <div className="bg-white rounded-lg shadow-2xl p-4 border-l-4 border-teal-600" data-id="element-198">
            <div className="flex items-start gap-3" data-id="element-199">
              <img src="https://images.unsplash.com/photo-1532619675605-1ede6c2ed2b0?w=100&q=80" alt="Kit Clínico Cognitivo" className="w-12 h-12 rounded object-cover flex-shrink-0" data-id="element-200" />
              <div className="flex-1 min-w-0" data-id="element-201">
                <p className="text-sm font-semibold text-gray-900" data-id="element-202">
                  {currentPurchase.name} de {currentPurchase.city}
                </p>
                <p className="text-xs text-gray-600 mt-1" data-id="element-203">
                  acaba de comprar{' '}
                  <span className="font-semibold" data-id="element-204">Kit Clínico Cognitivo™</span>
                </p>
                <p className="text-xs text-teal-600 mt-1" data-id="element-205">
                  hace {currentPurchase.time} minutos
                </p>
              </div>
              <button onClick={() => setIsVisible(false)} className="text-gray-400 hover:text-gray-600 transition-colors flex-shrink-0" data-id="element-206">
                <X className="w-4 h-4" data-id="element-207" />
              </button>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}